/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import filter from 'lodash/filter';
import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';
import { CAMPSITE_NOT_AVAILABLE } from '../constants/availability';
import { compileCurReleaseDataByCampsite } from '../utils/releasesUtils';
import {
    GET_CAMPGROUND,
    GET_CAMPGROUND_ERROR,
    GET_CAMPGROUND_TYPE_OF_USE,
    GET_RELEASE_DATES,
    GET_RELEASE_DATES_ERROR,
    GET_CAMPGROUND_SITE_TYPES_COUNT,
    GET_CAMPGROUND_SITE_TYPES_COUNT_ERROR,
    GET_CAMPGROUND_GALLERY,
    GET_CAMPGROUND_SCHEDULES,
    GET_CAMPGROUND_SCHEDULES_ERROR,
    GET_CAMPGROUND_SEARCH_RESULT,
} from '../constants';

const INITIALSTATE = {
    results: {
        facility_description: '',
        isLoading: true,
    },
    campsiteCount: {},
    typeOfUse: [],
    gallery: [],
    siteTypes: {},
    releaseDates: {},
    releaseDatesByCampsite: {},
    schedules: {},
    closures: {},
    searchResult: {},
};

export default function campground(state = INITIALSTATE, action) {
    let st;
    switch (action.type) {
        case GET_CAMPGROUND:
            return {
                ...state,
                ...{
                    results: {
                        ...action.payload,
                        isLoading: false,
                    },
                    isValid: true,
                },
            };
        case GET_CAMPGROUND_ERROR:
            return {
                ...state,
                ...{
                    error: action.error,
                    results: {
                        isLoading: false,
                    },
                    isValid: false,
                },
            };

        case GET_CAMPGROUND_TYPE_OF_USE:
            st = { ...state };
            st.typeOfUse = action.payload;
            return st;

        case GET_RELEASE_DATES:
            st = { ...state };
            st.releaseDates = action.payload;
            st.releaseDatesByCampsite = compileCurReleaseDataByCampsite({
                releasesData: action.payload,
            });
            return st;

        case GET_RELEASE_DATES_ERROR:
            return { ...state, ...{ error: action.error } };

        case GET_CAMPGROUND_SITE_TYPES_COUNT:
            st = { ...state };
            st.siteTypes = action.payload;
            return st;

        case GET_CAMPGROUND_SITE_TYPES_COUNT_ERROR:
            return { ...state, ...{ error: action.error } };

        case GET_CAMPGROUND_GALLERY:
            return { ...state, gallery: action.payload };

        case GET_CAMPGROUND_SCHEDULES:
            st = { ...state };
            st.schedules = action.payload;
            // filtering only campsites with closures
            st.closures = pickBy(
                action.payload,
                (schedules) =>
                    !isEmpty(
                        filter(schedules, (sch) => sch.status === CAMPSITE_NOT_AVAILABLE)
                    )
            );
            return st;

        case GET_CAMPGROUND_SCHEDULES_ERROR:
            return { ...state, ...{ error: action.error } };

        case GET_CAMPGROUND_SEARCH_RESULT:
            st = { ...state };
            st.searchResult = action.payload;
            return st;

        default:
            st = { ...state };
            return st;
    }
}
